import { render } from "./Fact.vue?vue&type=template&id=98366f06"
import script from "./Fact.vue?vue&type=script&lang=js"
export * from "./Fact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__